/**
 * @components review
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import { Pagination } from 'antd'
import { withTranslation } from 'react-i18next';

import './index.scss'

@withTranslation()

class Review extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    let { t } = this.props;
    let vedioList = [1, 1, 1, 1, 11, 11, 1, 1, 1, 1, 1]

    return (
      <div className="review">
        <div className="inner-title">{t('publicClass:review')}</div>
        <div className="review-list-wrap">
          <ul className="review-list">
            {vedioList.map((item, index) => (
              <li key={'review-' + index}>
                <div className="list-content">
                  <div className="list-text">
                    <span>茶</span>
                    <span>2019.8</span>
                  </div>
                </div>
              </li>
            ))}
            <li className="review-empty"></li>
            <li className="review-empty"></li>
            <li className="review-empty"></li>
          </ul>
        </div>
        <Pagination defaultCurrent={1} total={50} />
      </div>
    )
  }
}

export default Review
